<template>
	<div class="panel-index">
		<!-- Возможно, в будущем тут будет что-то другое, сейчас
		все не админы переходят на эту страницу -->
		<NotAccessToAdmin />
	</div>
</template>

<script>
export default {
	name: "PanelIndex",

	components: {
		NotAccessToAdmin: () => import("./NotAccessToAdmin.vue")
	}
}
</script>

<style lang="scss" scoped>
.panel-index {
}
</style>
